import { createReducer } from "typesafe-actions";

import { Actions as AppActions, initializeApp } from "@app/store/app/actions";

import { TrafficActions } from "./actions";
import TrafficLayerData from "./TrafficLayerData";

export const trafficInitialState: TrafficLayerData = {
  legendExpanded: false,
  visible: false,
};

const trafficLayer = createReducer<TrafficLayerData, AppActions | TrafficActions>(
  trafficInitialState
).handleAction(initializeApp.success, (state, { payload }) => ({
  ...state,
  ...(payload.metaData?.trafficSettings ?? {}),
}));

export default trafficLayer;
